import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
    getAssetImageUrl,
    getAssetTitle,
    getAssetSubtitle,
    getCarouselPackshotDimensionsByModelType,
    getImageKeyByItemType,
    getItemSubtitle,
    isArchive,
    isLiveTv,
    isActor,
    ITEM_TYPES,
    itemIsPlaying,
    getSearchVODAssetImageUrl
} from 'Utils/index';
import { useStore } from 'Store/Store';
import Packshot from 'LocalGluons/components/Packshot';
import Theme from 'Theme';
import { getParentalRatingByModel } from 'Utils/parentalControlUtils';
import { use } from 'i18next';
import { SearchResultModel } from '@24i/st-api-connector/interface/search/models/SearchResultModel';
import { TV_PLACEHOLDER, VOD_PLACEHOLDER, PERSON_PLACEHOLDER } from '../../../options';

const getProgress = (item) =>
    typeof item.getProgressPercent === 'function' &&
    item.modelType !== ITEM_TYPES.VOD &&
    !isArchive(item)
        ? item.getProgressPercent(new Date())
        : 0;

const getChannelIconUri = (data) =>
    data.data?.channelLogoUrl ||
    data.data?.channelLogo ||
    data.metadata?.channelLogo ||
    data.data?.metaData?.detail?.channelLogoUrl ||
    data.metadata?.metaData?.detail?.channelLogo;

const ItemContainer = ({
    item: { data, onItemPress },
    hideImage,
    style,
    forcePortraitViewDimensions,
    forceHideGradient,
    showMetadata
}) => {
    const [progress, setProgress] = useState(getProgress(data));
    const [packageImageUrl, setPackageImageUrl] = useState(data.data?.pckg?.imageUrl);

    useEffect(() => {
        setPackageImageUrl(data.data?.pckg?.imageUrl || data.data?.data?.pckg?.imageUrl);
    }, [data, data.data?.data?.pckg?.imageUrl]);

    useEffect(() => {
        let selfRefreshTimeout;
        if (itemIsPlaying(data)) {
            selfRefreshTimeout = setTimeout(() => setProgress(getProgress(data)), 60 * 1000);
        }
        return () => {
            clearTimeout(selfRefreshTimeout);
        };
    }, [data, progress]);

    const { deviceStorageState, language } = useStore();
    const lang = deviceStorageState?.language || language;

    const placeholderResolver = (data) => {
        if (isActor(data)) {
            return PERSON_PLACEHOLDER;
        }
        if (isLiveTv(data)) {
            return TV_PLACEHOLDER;
        }
        return VOD_PLACEHOLDER;
    };

    return (
        <Packshot
            item={data}
            id={data.listId}
            // key={data.listId}
            title={getAssetTitle(data)}
            subTitle={
                data.modelType === ITEM_TYPES.RECORDING_SERIES
                    ? getAssetSubtitle(data)
                    : getItemSubtitle(data, lang)
            }
            color={Theme.primaryTextColor}
            activeColor={Theme.primaryActiveColor}
            imageUri={
                data instanceof SearchResultModel
                    ? getSearchVODAssetImageUrl(data, getImageKeyByItemType(data), 'LOW')
                    : getAssetImageUrl(data, getImageKeyByItemType(data), 'LOW')
            }
            onPress={() => {
                onItemPress(data);
            }}
            progress={progress}
            style={style}
            iconUri={getChannelIconUri(data)}
            imageDimensions={getCarouselPackshotDimensionsByModelType(
                data.modelType,
                forcePortraitViewDimensions
            )}
            placeholderImage={placeholderResolver(data)}
            parentalRating={getParentalRatingByModel(data)}
            adult={data.isAdult()}
            hideImage={hideImage}
            packageImageUrl={packageImageUrl}
            forceHideGradient={forceHideGradient}
            showMetadata={showMetadata}
        />
    );
};

ItemContainer.defaultProps = {
    hideImage: false,
    forcePortraitViewDimensions: false,
    forceHideGradient: false,
    style: {},
    showMetadata: false
};

ItemContainer.propTypes = {
    item: PropTypes.shape({}).isRequired,
    hideImage: PropTypes.bool,
    forceHideGradient: PropTypes.bool,
    forcePortraitViewDimensions: PropTypes.bool,
    style: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.number]),
    showMetadata: PropTypes.bool
};

export default React.memo(ItemContainer);
